import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { View } from '@dbk/ui-react-utils';
import classNames from 'classnames';
import { createContainer } from '@dbk-legacy/muster/react';
import { List, ListItem } from '@dbk/ui-list';
import InverseProvider from '@dbk/ui-inverse';
import ReportUnreadCategoryListItem from './report-unread-category-list-item';
import withExtraProps from '../../../../../../src/common/components/utils/with-extra-props';
import ReportPreview from '../report-preview';
import { SUCCESS_RESPONSE_CODE, SELECTED_RANGE } from '../constants';
import download from '../../../../../../src/muster/utils/downloader';
import { LoadingCircle } from '../../../../../../src/components/common/loading';

class ReportUnreadCategoryDocListItem extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            modalVisible: false,
            documentId: null,
            docName: null,
            pdfByteStream: '',
            downloadInProgress: false,
            extType: '',
            documentType: '',
            newDocObj:''
        }
    }
    closePdf = () => {
        this.setState({ documentId: null });
    }

    closeBlurModel = () => {
        if (this.state.documentId != null) {
            return;
        }
        this.setState({ modalVisible: false, docName: null, documentId: null, pdfByteStream: '', extType: '', documentType: '' });
        // this.props.reports.setPdfBinaryData('');
        this.props.resetDocumentData();
        // if(this.props.reports.selectedReportDetailsDateRange === SELECTED_RANGE.CUSTOM){
        //     this.props.getCustomRangeDocuments(this.props.reports.startDate, this.props.reports.endDate);
        // }else{
        //     this.props.getDocuments();
        // }
    }

    onItemClicked = (document) => {
        this.setState({ modalVisible: true, documentId: document.documentId, docName: document.documentName,
            pdfByteStream: '', extType: '', documentType: '',  newDocObj: document});
        // this.props.downloadDocuments(document.documentId);
        this.downloader(document.documentId);
    }

    /* WMCE-3068 , documentDownloadDisabled flag added to disable download and preview on RM Login on Behalf */
    downloader = (documentId) => {
        // 16560003 csv
        // 13681003, 13687003, 13693003, 13696003, 13679003, 13680003, 13683003, 13689003, 13690003, 13697003, 13675003, 13676003
        // const filesToDownload = [13674003]; // 13678003, 13681003, 13687003, 13693003, 13696003, 13679003, 13680003, 13683003, 13689003, 13690003, 13697003, 13675003, 13676003];
        const {
            settings: { currentEnvironment: { remoteUrl } },
            auth: { userId, authHeader, langCode },
            i18n: { messages },
            auth: {documentDownloadDisabled}
          } = this.props;

        this.setState({ downloadInProgress: true });
        // const RSA_URL = remoteUrl + '/edelivery/' + this.props.app.config.apiverion + '/downloadDocumentsInBinary';
        const RSA_URL =  remoteUrl + '/edelivery/' + this.props.app.config.apiverion + '/downloadDocumentsInBinary';

        const body = { "userId": userId, "branchCode": this.props.app.user.selectedPortfolio.branchCode, "channel": "WEB", "language": langCode, "documentIds": [documentId] };
        const documentName = '';
        const that = this;

        const x = new XMLHttpRequest();
        x.open('POST', RSA_URL, true);
        x.setRequestHeader('Authorization-Token', authHeader);
        x.setRequestHeader('content-type', 'application/json');
        x.setRequestHeader('Accept', 'application/octet-stream');
        // x.setRequestHeader('Authorization', 'Bearer 6265acfa8564872ddfcbaca12e2b0d5b');
        x.setRequestHeader(
            'Content-Disposition',
            'inline; filename=' + documentName
        );
        x.setRequestHeader(
            'Cache-Control',
            'no-cache, no-store, must-revalidate'
        );
        x.setRequestHeader('Pragma', 'no-cache');
        x.setRequestHeader('Expires', '0');
        x.responseType = 'arraybuffer';
        x.timeout = 300000;
        x.ontimeout = function () { that.props.setBlurModalError(messages['app.chedelivery.reports.systemErrorMessage']); }

        x.onload = function (e) {
            // that.setState({pdfByteStream:x.response,  downloadInProgress: false});
            if (x.status === SUCCESS_RESPONSE_CODE) {
                const documentType = x.getResponseHeader('content-type');
                // const ext = documentType.split('/');
                let ext = '';
                if (documentType.includes('/pdf')) {
                    ext = '.pdf';
                } else {
                    ext = '.' + documentType.split(';')[0].split('/')[1];
                }

                if(!that.state.modalVisible){
                    return;
                }

                if (that.detectIE()) {
                    if(!documentDownloadDisabled){
                    download(x.response, that.state.docName + ext, documentType); // text/csv and
                    if(that.props.reports.selectedReportDetailsDateRange === SELECTED_RANGE.CUSTOM){
                        that.props.getCustomRangeDocuments(that.props.reports.startDate, that.props.reports.endDate);
                    }else{
                        that.props.getDocuments();
                    }
                    that.setState({ modalVisible: false, docName: null, documentId: null, pdfByteStream: '', extType: '', documentType: '', downloadInProgress: false });
                    return;
                    }else {
                    that.setState({ modalVisible: false, docName: null, documentId: null, pdfByteStream: '', extType: '', documentType: '', downloadInProgress: false });
                    that.props.setBlurModalError(messages['app.rmAccess.genericError']);
                    return;
                }
            }

                if (ext !=='.pdf') {
                    if(!documentDownloadDisabled){
                    // that.setState({ pdfByteStream: x.response, extType: ext, documentType, errorHeader: messages['app.chedelivery.reports.unsupportedTypeHeader'], downloadInProgress: false });
                    download(x.response, that.state.docName + ext, documentType); // text/csv and
                    if(that.props.reports.selectedReportDetailsDateRange === SELECTED_RANGE.CUSTOM){
                        that.props.getCustomRangeDocuments(that.props.reports.startDate, that.props.reports.endDate);
                    }else{
                        that.props.getDocuments();
                    }
                    that.setState({ modalVisible: false, docName: null, documentId: null, pdfByteStream: '', extType: '', documentType: '', downloadInProgress: false });
                    }
                    else {
                    that.setState({ modalVisible: false, docName: null, documentId: null, pdfByteStream: '', extType: '', documentType: '', downloadInProgress: false });
                    that.props.setBlurModalError(messages['app.rmAccess.genericError']);
                    }
                }
                else
                    that.setState({ pdfByteStream: x.response, extType: ext, documentType, downloadInProgress: false });

                // if(ext === CSV || ext === TXT){
                //     that.setState({pdfByteStream:x.response, extType:ext, documentType, errorHeader:messages['app.chedelivery.reports.unsupportedTypeHeader'], downloadInProgress:false});
                // }else{
                //     that.setState({pdfByteStream:x.response, extType:ext, documentType, downloadInProgress:false});
                // }
            } else {
                that.setState({ modalVisible: false, docName: null, documentId: null, pdfByteStream: '', extType: '', documentType: '', downloadInProgress: false });
                that.props.setBlurModalError(messages['app.chedelivery.reports.systemErrorMessage']);
            }
        };
        x.send(JSON.stringify(body));
        x.onerror = function (e) {
            that.setState({ modalVisible: false, docName: null, documentId: null, pdfByteStream: '', extType: '', documentType: '', downloadInProgress: false });
            that.props.setBlurModalError(messages['app.chedelivery.reports.systemErrorMessage']);
        };
    }

    detectIE = () => {
        const ua = window.navigator.userAgent;
        const msie = ua.indexOf('MSIE '); // IE 10 or older => return version number
        const trident = ua.indexOf('Trident/'); // IE 11 => return version number
        const edge = ua.indexOf('Edge/'); // IE 12 => return version number
        if (msie > 0 || trident > 0 || edge > 0) {
            return true;
        }
        return false;
    }

    // method to render report row
    renderReportRow = (dataForRendering) => {
        const lastRowLen = dataForRendering.length;
        return dataForRendering.map((item, i) => {
            if (i === (lastRowLen - 1)) {
                this.props.setIsScrollLoading(false);
            }
            return (
            // <ListItem inverse style={{ width: "100%", padding: 0 }}>
            <View>
                <ReportUnreadCategoryListItem item={item} showPdf
                    isFirstItem={i === 0}
                    showSeperator={i !== (lastRowLen - 1)}
                    handleReportItemClick={this.props.handleReportItemClick}
                    handlePreviewClick={this.onItemClicked} />
            </View>
            // </ListItem>
            )
        })
    }

    handlePagination = () => {
        const { reports: { isActiveItemChanged } } = this.props;
        if (isActiveItemChanged) {
            this.props.activeItemChanged(false)
        }
    }

    render() {
        const { i18n: { messages }, screen, reports: { isScrollLoading },  isActive, categoryReportList } = this.props;
        const dataForRendering = categoryReportList;
        return (
            <div className="large-12">
                <InverseProvider inverse style={{ width: "100%", display: "inline" }}>
                    {/* <List className="scrollBarHover" style={{ maxWidth: "100%" }}> */}
                        {this.renderReportRow(dataForRendering)}
                    {/* </List> */}
                </InverseProvider>
                {this.handlePagination()}

                {isScrollLoading && <LoadingCircle />}
                <ReportPreview
                    screen={screen}
                    modalVisible={this.state.modalVisible}
                    doneLabel="Close"
                    onCloseBlurModel={this.closeBlurModel}
                    headerLabel={this.state.docName}
                    closePdf={this.closePdf}
                    pdfData={this.state.pdfByteStream}
                    messages={messages}
                    pdfDataDownloadInProgress={this.state.downloadInProgress}
                    extType={this.state.extType}
                    documentType={this.state.documentType}
                    documentName={this.state.newDocObj}
                    documentDownloadDisabled = {this.props.auth.documentDownloadDisabled}
                />
            </div>
        );
    }
}

ReportUnreadCategoryDocListItem.propTypes = {
    i18n: PropTypes.shape({
        messages: PropTypes.object,
    }),
};

ReportUnreadCategoryDocListItem.defaultProps = {
    i18n: {},
};
export default createContainer({
    $queries: {
        changePage: { $call: 'ui.history.push' },
        i18n: {
            messages: true,
        },
        getDocuments: {
            $call: 'reports.getDocuments',
        },
        downloadDocuments: {
            $call: 'reports.downloadDocuments'
        },
        setBlurModalError: {
            $call: 'reports.setBlurModalError'
        },
        resetDocumentData: {
            $call: 'reports.resetDocumentData'
        },
        settings: {
            currentEnvironment: {
                remoteUrl: true,
            },
        },
        app: {
            config: {
                apiverion: true
            },
            user: {
                selectedPortfolio: true
            }
        },
        auth: {
            userId: true,
            authHeader: true,
            langCode: true,
            documentDownloadDisabled: true,
        },
        setIsScrollLoading: {
            $set: 'reports.isScrollLoading'
        },
        activeItemChanged: {
            $set: 'reports.isActiveItemChanged'
        },
        getCustomRangeDocuments: {
            $call: 'reports.fetchDocumentsForCategories'
        },
        reports: {
            pdfBinaryData: true,
            setPdfBinaryData: {
                $set: 'pdfBinaryData',
            },
            pdfDataDownloadInProgress: true,
            startDate:true,
            endDate:true,
            selectedReportDetailsDateRange: true,
        },
        screen: {
            width: true,
            height: true,
            isSmall: true
        },
    },
})(ReportUnreadCategoryDocListItem);

